import { useTranslation } from 'react-i18next'
import { routes } from 'core/routes/paths'
import { Link } from 'react-router-dom'
import cn from 'classnames'

import c from './assets/sass/item.module.scss'

export const Item = ({ type, title, subTitle, comingSoon = false, soonText }) => {
    const { t } = useTranslation()
    const getRoute = (gameType) => {
        switch (gameType) {
            case 'advent':
                return routes.advent
            case 'mines':
                return routes.mines
            case 'battles':
                return routes.battle
            default:
                return routes.main
        }
    }

    return (
        <li
            className={cn(c.component, {
                [c.soon]: comingSoon,
            })}
        >
            <Link
                className={cn(c.row, {
                    [c.advent]: type === 'advent',
                    [c.mines]: type === 'mines',
                    [c.battles]: type === 'battles',
                })}
                to={getRoute(type)}
            >
                <div className={c.text}>
                    <span className={c.title}>{title}</span>
                    <span className={c.subTitle}>{subTitle}</span>
                </div>
            </Link>

            {comingSoon && (
                <div className={c.comingSoon}>{soonText || t('games.comingSoon')}</div>
            )}
        </li>
    )
}
